import { CircularProgress } from "@mui/material";
import { useState } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  Text,
} from "recharts";

interface Props {
  revenueGraphData: any;
  loading: boolean;
  Saturdays: any;
  Sundays: any;
}

const RevenueGraph = ({
  revenueGraphData,
  loading,
  Saturdays,
  Sundays,
}: Props) => {
  const [activeBarIndex, setActiveBarIndex] = useState<any>();

  // console.log("revenueGraphData",revenueGraphData)

  const CustomTick = ({ x, y, payload }: any) => {
    const isSaturday = Saturdays.includes(payload.index + 1);
    const isSundays = Sundays.includes(payload.index + 1);
    const fill = isSaturday || isSundays ? "red" : "#A3AED0";

    return (
      <Text
        x={x}
        y={y}
        fill={fill}
        fontSize={12}
        fontWeight="500"
        textAnchor="inherit"
      >
        {payload.value}
      </Text>
    );
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={"100%"}>
        <BarChart
          width={500}
          // height={300}
          data={revenueGraphData}
          margin={{
            top: 5,
            right: 5,
            left: -28,
            bottom: 16,
          }}
        >
          {revenueGraphData.length > 0 && !loading ? (
            <>
              <CartesianGrid strokeOpacity={0.3} />
              <XAxis
                dataKey="date"
                padding={{ left: 10, right: 10 }}
                tickLine={false}
                tickSize={10}
                axisLine={true}
                scale="point"
                tick={{ fontSize: 12, fill: "#A3AED0", fontWeight: "500" }}
                // tick={<CustomTick  />}
                strokeOpacity={0.1}
              />
              <YAxis
                tickLine={false}
                tickSize={4}
                axisLine={true}
                tick={{
                  fontSize: 12,
                  fill: "#A3AED0",
                  fontWeight: "500",
                  width: "fit-content",
                }}
                width={70}
                color="#F1F2F3"
                strokeOpacity={0.1}
              />
              <Tooltip
                // itemStyle={{ color: "rgba(0, 103, 121, 1)" }}
                // position={{ x: 300, y: -100 }}
                content={<CustomTooltip />}
              />
              <Bar
                dataKey="Introducer_Commission"
                onMouseEnter={(_, index: any) => setActiveBarIndex(index)}
                onMouseLeave={() => setActiveBarIndex(null)}
                radius={[8, 8, 8, 8]}
              >
                {revenueGraphData.map((entry: any, index: any) => (
                  <Cell
                    cursor="pointer"
                    fill={
                      index === activeBarIndex
                        ? "#092c32"
                        : "rgba(0, 103, 121, 1)"
                    }
                    key={entry.id}
                    // width={20}
                  />
                ))}
              </Bar>
              {/* <Bar
                dataKey="Introducer_Commission"
                fill={"rgba(0, 103, 121, 1)"}
                focusable
                radius={[8, 8, 8, 8]}
                onMouseOver={(data: any, index: any) => setbgColorChange(index)}
              /> */}
            </>
          ) : (
            <>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="16"
                fill="#888"
              >
                {loading ? "Loading..." : "No Data Found"}
              </text>
            </>
          )}
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default RevenueGraph;

const CustomTooltip = ({ active, payload, label }: any) => {
  // console.log("active", active, "label", label, "payload", payload);
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "rgba(213, 233, 236, 1)",
          border: "1px solid rgba(0, 103, 121, 1)",
          borderRadius: "10px",
          padding: "5px 10px",
        }}
      >
        <p style={{ fontSize: "12px", fontWeight: 400 }}>{`Date ${label}`}</p>
        <p
          style={{ fontSize: "14px", fontWeight: 500 }}
        >{`₹${payload[0]?.payload?.Introducer_Commission}`}</p>
      </div>
    );
  }

  return null;
};
